import { PlusShopCreatorPage } from './PlusShopCreatorPage';

export const plusShopCreatorRouter = {
  '/@/creators': PlusShopCreatorPage,
};
